import XAxis from './XAxis'

export default XAxis
